import { validationMessages, validationRegexes } from '../../../utils';
import { z } from 'zod';
import { isMongoId } from '../../helpers';

export const updateProfileInput = z.object({
  firstName: z
    .string()
    .min(1, 'Please enter your first name.')
    .regex(validationRegexes.userName, validationMessages.nameValidationError),
  lastName: z
    .string()
    .min(1, 'Please enter your surname.')
    .regex(validationRegexes.userName, validationMessages.nameValidationError),
  email: z
    .string()
    .min(1, 'Please enter email address.')
    .email({ message: 'Please enter a valid email address.' }),
  profilePic: z.string().optional(),
  updates: z.array(z.string()).optional(),
});

export const requestPasswordResetForUserInput = z.object({
  id: z.string().refine(isMongoId()),
});

export const updateUserInputForCurrentFirm = z.object({
  adminUserId: z.string().refine(isMongoId()),
  firstName: z
    .string()
    .min(1, 'Please enter first name.')
    .regex(validationRegexes.userName, validationMessages.nameValidationError),
  lastName: z
    .string()
    .min(1, 'Please enter last name.')
    .regex(validationRegexes.userName, validationMessages.nameValidationError),
  perFirmSettings: z
    .object({
      isAllVehiclesMember: z.boolean().optional(),
      vehicleIds: z
        .array(z.string().refine(isMongoId({ optional: true })))
        .optional(),
    })
    .refine((data) => !data.isAllVehiclesMember || !data.vehicleIds?.length, {
      message: 'Vehicle IDs must be empty when granting access to all vehicles',
      path: ['vehicleIds'],
    })
    .optional(),
  newAuth0RoleId: z.string().optional(),
});

export const createUserInputForCurrentFirm = z.object({
  firstName: z
    .string()
    .min(1, 'Please enter first name.')
    .regex(validationRegexes.userName, validationMessages.nameValidationError),
  lastName: z
    .string()
    .min(1, 'Please enter last name.')
    .regex(validationRegexes.userName, validationMessages.nameValidationError),
  email: z
    .string()
    .min(1, 'Please enter an email address.')
    .email({ message: 'Please enter a valid email address.' }),
  auth0RoleId: z.string().min(1, 'Please select a role.'),
});
